<template>
  <div class="startup-links">
    <div class="row actions-row">
      <div class="col-sm-4">
        <input
          ref="input"
          v-model="name"
          class="form-control"
          placeholder="Name"
          @keyup.enter="addLink()"
        />
      </div>
      <div class="col-sm-2">
        <button
          :disabled="!name"
          class="btn btn-secondary btn-transparent"
          @click="addLink()"
        >
          <loader v-show="addLinkInProgress" class="is-black" />
          Add Link
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <table class="table">
          <tbody>
            <tr v-for="link in links" class="link-row" :key="link.id">
              <td>{{ link.name }}</td>
              <td>
                <button
                  v-clipboard
                  type="button"
                  class="btn btn-success btn-sm copy-link"
                  :data-clipboard-text="getPrivateUrl(link.id)"
                >
                  Click to copy link
                </button>
              </td>
              <td>{{ link.visits || 0 }} visits</td>
              <td>
                <i
                  class="remove-link ion ion-close-circled"
                  @click="removeLink(link)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>

        <p v-show="!links.length" class="text-muted">
          No links yet
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { resolveFullUrl } from '@/utils/urls'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: mapState({
    user: (state) => state.user.data,
    links: (state) => _.sortBy(state.startupProfile.links, 'name'),
    startup: (state) => state.startupProfile.startup,
  }),
  data: () => ({ name: '', addLinkInProgress: false }),
  mounted() {
    this.$refs.input.focus()
  },
  methods: {
    async addLink() {
      if (!this.name) {
        console.warn(' => Cannot send form without a link name')
        return
      }
      this.addLinkInProgress = true
      try {
        await this.$store.dispatch('startupProfile/addLink', {
          name: this.name,
        })
      } catch (error) {
        console.log(' errors:', error.response.data)
      }
      this.addLinkInProgress = false
      this.name = ''
      this.$refs.input.focus()
    },
    async removeLink(link) {
      await this.$store.dispatch('startupProfile/removeLink', { id: link.id })

      const notification = {
        title: `Link "${link.name}"`,
        type: 'warning',
        timeout: 5000,
        action: {
          label: 'Cancel action',
          callback: () => {
            self.$store.dispatch('startupProfile/restoreLink', link)
          },
        },
      }

      self.$store.dispatch('notifications/addItem', notification)
    },
    getPrivateUrl(linkId) {
      const slug = this.startup.slug
      const startupId = this.startup.id
      return resolveFullUrl('privateStartupProfile', {
        slug,
        startupId,
        linkId,
      })
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.startup-links {
  .remove-link {
    visibility: hidden;
    cursor: pointer;

    &:hover {
      color: $danger;
    }
  }

  .actions-row {
    margin-top: 10px;
    height: 50px;
  }

  .table {
    td {
      .copy-link {
        //width: 300px;
      }
    }
  }

  .link-row:hover .remove-link {
    visibility: visible;
  }
}
</style>
